import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const SwayLogoFill16Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1088 192h896v1664h-896V192zM976 1256q0 86-27 155t-76 118-119 75-155 26q-50 0-90-6t-77-18-72-32-76-48l-4-18q-2-9-2-19v-435q31 35 64 76t70 76 81 60 97 24l14-4 7-15q-1-21-26-41t-62-44-81-55-80-75-62-104-25-142q0-94 31-167t86-123 132-76 168-26q66 0 120 13t116 38q2 11 5 23t4 24v393q-27-22-57-48t-63-48-69-38-74-16q-10 0-21 1t-20 7l-8 10q-1 5-1 9t0 7v5q0 17 26 34t65 41 85 54 85 77 65 107 26 145z" />
    </svg>
  ),
  displayName: 'SwayLogoFill16Icon',
});

export default SwayLogoFill16Icon;
